import React from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { Link } from "@quintype/components";
import "./paywall.m.css";

export const Paywall = () => {
  const member = useSelector((state) => get(state, ["member"], null));

  return (<React.Fragment>
    <div styleName="pricing-card">
      <div styleName="pricing-header"><h2>Tilaa katselua varten!</h2></div>
      <div styleName="paywall-container">
        <p styleName="paywall-description">
          Tämä jakso on lukittu. Tilaa palvelu saadaksesi täyden pääsyn ja keskeytyksettömän katselun.
        </p>
        <div styleName="pricing-button-wrapper">
          <Link href="/tilaus" styleName="pricing-button">
            Tutustu tilausvaihtoehtoihin
          </Link>
        </div>
        {!member && (
          <div styleName="go-to-login">
            Onko sinulla jo tilaus? Kirjaudu sisään
            <Link href="/user-login" styleName="go-to-login-link">
              Kirjaudu
            </Link>
          </div>
        )}
      </div>
      <div styleName="bottom-red-border"></div>
    </div>
    </React.Fragment>);
};
